import { FormattedNumber } from 'i18n'

import Modal from '@components/Modal'
import PriceBreakdown from '@components/PriceBreakdown'
import BookingSummary from '@components/BookingSummary'
import { currencyFromSymbol } from 'shared/currency-utilities'
import { getTotalPrice } from 'shared/price-utilities'

import { basketSelector, addressToStringSelector, totalSelector } from 'basket/selectors'
import { lastBookingBasketItemSelector, selectedVehicleSelector } from 'booking/selectors'

const PriceBreakdownModal = ({
    onClose,
    isLoading,
    basket,
    basketTotal,
    lastBookingBasketItem,
    deliveryAddress,
    selectedVehicles,
    disabled,
    error,
    onClick,
    onClickButtonLabel,
    eventBrFlow,
    additionalServices,
    additionalServicePrice,
    editedReservationNewTotalPrice,
    newPrice,
    oldPrice,
    amendmentFee,
    showPriceDifference,
}) => {
    // Checking for more than 1 key since lastBookingBasketItem.rate always contains one key (waitingListKey)
    const items =
        lastBookingBasketItem && Object.keys(lastBookingBasketItem.rate).length > 1
            ? [lastBookingBasketItem]
            : basket.items
    const isMultipleBooking = items && items.length > 1
    const currencySymbol = items && items[0].rate.currencySymbol
    const itemRateName = items[0].rate.rateName
    const rate = items[0].rate

    return (
        <Modal
            onClose={onClose}
            loading={isLoading}
            disabled={disabled}
            header={itemRateName}
            error={error}
            size="large"
            buttons={[{ label: onClickButtonLabel || <T>booking.pay.for.parking</T>, onClick: onClick }]}>
            <main>
                {items.length !== 0 &&
                    items.map((item, index) => (
                        <React.Fragment key={index}>
                            <BookingSummary
                                location={item.rate.locationName}
                                fromDateTime={item.rate.fromDateISO || item.rate.fromDate}
                                toDateTime={item.rate.toDateISO || item.rate.toDate}
                                vehicles={item.vehicles || selectedVehicles}
                                deliveryAddress={item.rate.isMonthlyPass ? deliveryAddress : ''}
                            />
                            <PriceBreakdown
                                itemTotal={getTotalPrice(item)}
                                total={isMultipleBooking ? basketTotal : getTotalPrice(item)}
                                rateTable={eventBrFlow ? [item.rate] : item.rate.rateTable}
                                promoCode={item.promoCode}
                                currencySymbol={currencySymbol}
                                isMultipleBooking={isMultipleBooking}
                                additionalServices={additionalServices}
                                additionalServicePrice={additionalServicePrice}
                                editedReservationNewTotalPrice={editedReservationNewTotalPrice}
                                newPrice={newPrice}
                                oldPrice={oldPrice}
                                amendmentFee={amendmentFee}
                                rate={rate}
                                showPriceDifference={showPriceDifference}
                            />
                            {isMultipleBooking && <hr className="price-summary__break" />}
                        </React.Fragment>
                    ))}
                {isMultipleBooking && basketTotal != null && (
                    <p className="d-flex justify-content-between price-summary__sum-container">
                        <T>basket.total.to.pay.label</T>
                        <span className="price-summary__price">
                            <FormattedNumber
                                value={basketTotal}
                                style="currency"
                                currency={currencyFromSymbol(currencySymbol)}
                            />
                        </span>
                    </p>
                )}
            </main>
        </Modal>
    )
}

const mapStateToProps = createStructuredSelector({
    basket: basketSelector,
    basketTotal: totalSelector,
    lastBookingBasketItem: lastBookingBasketItemSelector,
    deliveryAddress: addressToStringSelector,
    selectedVehicles: selectedVehicleSelector,
})

export default connect(mapStateToProps)(PriceBreakdownModal)
